import axios from "axios";
import { obtenirValeur } from "../utils/localStorageUtil";

export function obtenir_tous_les_roles(state, setState)
{
    const token = obtenirValeur("token", false)
    axios.get(
        process.env.REACT_APP_NOM_DOMAINE_API + "/roles",
        {
            "headers": {
                "Authorization": "Bearer " + token
            }
        }
    )
        .then((response) => {
            if(response.status === 200)
            {
                setState({
                    ...state,
                    roles: response.data.contenu
                })
                return;
            }
            setState({
                ...state,
                roles: []
            })
        })
        .catch((error) => {
            setState({
                ...state,
                roles: []
            })
        })
}